import { Fragment, useState } from "react";
import PropTypes from "prop-types";
import { NavLink } from "react-router-dom";
import { Popover, Button } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";

export const Card = ({
  subTitle,
  mainTitle,
  time,
  price,
  style = {},
  description = "",
  bookNowLink = (
    <NavLink to="/bookwithus">
      <button className="desktop-button">Book Now</button>
    </NavLink>
  ),
  previousPrice = price,
  earlyBirdEndDate = null,
  earlyBirdDiscount = null,
  priceType = "",
  showPrice = false,
  priceInfo = null,
}) => {

  const [popoverVisible, setPopoverVisible] = useState(false);
  const [priceInfoVisible, setPriceInfoVisible] = useState(false);

  // Check if early bird is active
  const isEarlyBirdActive = earlyBirdEndDate
    ? new Date() <= new Date(earlyBirdEndDate)
    : false;

  // Get early bird discount values from props or use defaults
  const discountAmount = earlyBirdDiscount?.discountAmount || 500;
  const originalPrice = earlyBirdDiscount?.originalPrice || 4500;
  const discountedPrice = earlyBirdDiscount?.discountedPrice || 4300;
  const discountMessage = earlyBirdDiscount?.message || "Flat Rs 500 off valid until 18th January 2026";

  const earlyBirdTooltipContent = (
    <div style={{ padding: "4px 0" }}>
      <div
        style={{
          fontSize: "12px",
          fontWeight: 600,
          marginBottom: "4px",
          color: "#d97706",
        }}
      >
        Early Bird Offer
      </div>
      <div style={{ fontSize: "11px", color: "#666" }}>
        {discountMessage}
      </div>
    </div>
  );

  Card.propTypes = {
    badgeText: PropTypes.string.isRequired,
    subTitle: PropTypes.string.isRequired,
    mainTitle: PropTypes.string.isRequired,
    time: PropTypes.string.isRequired,
    // Call sites pass pre-formatted strings such as "₹3699/- onwards".
    price: PropTypes.node.isRequired,
    priceType: PropTypes.string,
    previousPrice: PropTypes.node,
    description: PropTypes.string,
    bookNowLink: PropTypes.node,
    style: PropTypes.object,
    showPrice: PropTypes.bool,
    priceInfo: PropTypes.node,
    earlyBirdEndDate: PropTypes.string,
    earlyBirdDiscount: PropTypes.shape({
      discountAmount: PropTypes.number,
      originalPrice: PropTypes.number,
      discountedPrice: PropTypes.number,
      message: PropTypes.string,
    }),
  };

  return (
    <div className="helitaxii_card" style={style}>
      {isEarlyBirdActive && earlyBirdDiscount && (
        <div className="card_badge card_early_bird_badge">
          <span className="early_bird_label">Early Bird Offer</span>
          <span className="early_bird_price">₹{discountedPrice.toLocaleString("en-IN")}</span>
          <span className="early_bird_original_price">{originalPrice.toLocaleString("en-IN")}</span>
          <Popover
            content={earlyBirdTooltipContent}
            title={null}
            trigger="hover"
            placement="top"
            visible={popoverVisible}
            onVisibleChange={setPopoverVisible}
          >
            <Button
              type="text"
              icon={<InfoCircleOutlined />}
              className="early_bird_info_icon"
            />
          </Popover>
        </div>
      )}
      <div className="card_subTitle">{subTitle}</div>
      <div className="card_title">{mainTitle}</div>

      <div className="card_passengers">{time}</div>
      <div className="card_description">{description}</div>
      {showPrice && (
        <Fragment>
          <div className="card_price_row">
            <span className="card_price">{price}</span>
            {priceInfo && (
              <Popover
                content={priceInfo}
                title={null}
                trigger="hover"
                placement="top"
                visible={priceInfoVisible}
                onVisibleChange={setPriceInfoVisible}
              >
                <Button
                  type="text"
                  icon={<InfoCircleOutlined />}
                  className="card_price_info_icon"
                  aria-label="View detailed fares"
                />
              </Popover>
            )}
          </div>
          {priceType && <div className="card_price_type">{priceType}</div>}
        </Fragment>
      )}
      <div className="buttonWrapper">{bookNowLink}</div>
    </div>
  );
};
